module.exports = evite.exports.ReactRedux;